import { render, staticRenderFns } from "./PColorPicker.vue?vue&type=template&id=55f992b2&"
import script from "./PColorPicker.vue?vue&type=script&lang=js&"
export * from "./PColorPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports